export default () => Math.random().toString(12).substring(2);